import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import tippy from 'tippy.js'

const MembershipOrder = ({ user, isLoading, style, history, showGear }) => {
  const containerRef = useRef()
  const [extraRetail, setExtraRetail] = useState(0)
  const [subscriptionRetail, setSubscriptionRetail] = useState(0)
  const [customTippy, setCustomTippy] = useState()

  useEffect(() => {
    const totalOrderPopup = document.getElementById('total-order-popup')
    if (customTippy)
      customTippy.setProps({
        content: totalOrderPopup.innerHTML,
        animation: 'shift-away',
        zIndex: 1020,
        appendTo: containerRef.current,
        allowHTML: true,
      })
  }, [customTippy])

  useEffect(() => {
    if (user !== null) {
      let totalExtra = 0,
        totalSubscription = 0

      totalExtra += parseInt(user.retail && user.retail.totalOrderExtra)
      totalSubscription += parseInt(
        user.retail ? user.retail.totalOrderSubscription : 0
      )
      if (totalExtra > 0) setExtraRetail(totalExtra)
      if (totalSubscription > 0) setSubscriptionRetail(totalSubscription)
    }

    const totalOrderPopup = document.getElementById('total-order-popup')
    const customTippy = tippy(containerRef.current, {
      content: totalOrderPopup.innerHTML,
      animation: 'shift-away',
      zIndex: 1020,
      appendTo: containerRef.current,
      allowHTML: true,
    })

    setCustomTippy(customTippy)
  }, [user])

  if ((user === null && isLoading) || (user === null && !isLoading)) {
    return null
  }

  const used = user.membership.orders.used
    ? parseInt(user.membership.orders.used)
    : 0

  return (
    <div
      className="membership-status"
      ref={containerRef}
      style={Object.assign(style, {})}
    >
      {/* 
        Tippy custom HTML
      */}
      <div id="total-order-popup" style={{ display: 'none' }}>
        <span>
          The total orders available to use in your current subscription.
        </span>
        {(extraRetail > 0 || subscriptionRetail > 0) && (
          <>
            <div>
              <div className="d-flex justify-content-between mt-2">
                <div>{user.membership.title} membership</div>
                <div>{user.membership.orders.quota} orders</div>
              </div>
              {subscriptionRetail > 0 && (
                <div className="d-flex justify-content-between mt-1 text-subscription-retail">
                  <div>Subscription Total Order</div>
                  <div>{user.retail.totalOrderSubscription} orders</div>
                </div>
              )}
              {extraRetail > 0 && (
                <>
                  <div className="d-flex justify-content-between mt-1 text-extra-retail">
                    <div>Extra Total Order</div>
                    <div>{user.retail.totalOrderExtra} orders</div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
      <div className="clearfix text-membership-status w-100">
        <div className="float-left d-flex">
          <span className="text-12 text-light">Used Orders</span>
          {subscriptionRetail > 0 && (
            <span className="dot-subscription-retail"> </span>
          )}
          {extraRetail > 0 && <span className="dot-extra-retail"> </span>}
        </div>
        <div className="float-right clearfix d-flex align-items-center">
          <div
            className={`text-12 d-flex flex-row align-items-center text-light`}
          >
            <strong>{used}</strong>
            <strong>&nbsp;Orders</strong>
          </div>
        </div>
      </div>
    </div>
  )
}

MembershipOrder.propTypes = {
  style: PropTypes.object,
}

MembershipOrder.defaultProps = {
  showGear: true,
}

export default withRouter(MembershipOrder)
